import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Grid, Table } from 'semantic-ui-react';
import moment from 'moment';

const AdditionalDetailsLocation = props => {
  const dateformat = 'MM/DD/YYYY HH:mm';
  const { location, onCloseHandler } = props;

  const styles = {
    compactRow: {
      paddingTop: '0',
      paddingBottom: '0',
    },
    labelColored: {
      color: '#4183c4',
    },
    labelBold: {
      fontWeight: '700',
    },
    detailMargin: {
      marginLeft: '1rem',
    },
  };

  return (
    <Modal
      open
      closeIcon
      onClose={onCloseHandler}
      closeOnEscape={false}
      closeOnRootNodeClick={false}
    >
      <Modal.Header>
        Additional Details for {location.locationName}
      </Modal.Header>
      <Modal.Content>
        <Grid>
          {/* Location ID */}
          <Grid.Row>
            <Grid.Column width={16}>
              <h4>Location ID: {location.locationId}</h4>
            </Grid.Column>
          </Grid.Row>
          {/* Active Dates */}
          <Grid.Row style={{ paddingBottom: 0, paddingTop: '1rem' }}>
            <Grid.Column width={16}>
              <span style={{ ...styles.labelColored, ...styles.labelBold }}>
                Active Dates
              </span>
            </Grid.Column>
          </Grid.Row>
          {/* DS Start label & DS End label */}
          <Grid.Row>
            <Grid.Column width={8}>
              <span style={styles.labelBold}>DS Start</span>
            </Grid.Column>
            <Grid.Column width={8}>
              <span style={styles.labelBold}>DS End</span>
            </Grid.Column>
          </Grid.Row>
          {/* DS Start value & DS End value */}
          <Grid.Row style={styles.compactRow}>
            <Grid.Column width={8}>
              <span style={styles.detailMargin}>
                {location.dsStartDate
                  ? moment(location.dsStartDate).format(dateformat)
                  : ''}
              </span>
            </Grid.Column>
            <Grid.Column width={8}>
              <span style={styles.detailMargin}>
                {location.dsEndDate
                  ? moment(location.dsEndDate).format(dateformat)
                  : ''}
              </span>
            </Grid.Column>
          </Grid.Row>
          {/* PSI Start label & PSI End label */}
          <Grid.Row>
            <Grid.Column width={8}>
              <span style={styles.labelBold}>PSI Start</span>
            </Grid.Column>
            <Grid.Column width={8}>
              <span style={styles.labelBold}>PSI End</span>
            </Grid.Column>
          </Grid.Row>
          {/* PSI Start value & PSI End value */}
          <Grid.Row style={styles.compactRow}>
            <Grid.Column width={8}>
              <span style={styles.detailMargin}>
                {location.psiStartDate
                  ? moment(location.psiStartDate).format(dateformat)
                  : ''}
              </span>
            </Grid.Column>
            <Grid.Column width={8}>
              <span style={styles.detailMargin}>
                {location.psiEndDate
                  ? moment(location.psiEndDate).format(dateformat)
                  : ''}
              </span>
            </Grid.Column>
          </Grid.Row>
          {/* DS Paid PSI Start label & DS Paid PSI End label */}
          <Grid.Row>
            <Grid.Column width={8}>
              <span style={styles.labelBold}>DS Paid PSI Start</span>
            </Grid.Column>
            <Grid.Column width={8}>
              <span style={styles.labelBold}>DS Paid PSI End</span>
            </Grid.Column>
          </Grid.Row>
          {/* DS Paid PSI Start value & DS Paid PSI End value */}
          <Grid.Row style={styles.compactRow}>
            <Grid.Column width={8}>
              <span style={styles.detailMargin}>
                {location.dsPsiStartDate
                  ? moment(location.dsPsiStartDate).format(dateformat)
                  : ''}
              </span>
            </Grid.Column>
            <Grid.Column width={8}>
              <span style={styles.detailMargin}>
                {location.dsPsiEndDate
                  ? moment(location.dsPsiEndDate).format(dateformat)
                  : ''}
              </span>
            </Grid.Column>
          </Grid.Row>
          {/* Ineligible Lanes */}
          <Grid.Row style={{ paddingBottom: 0, paddingTop: '2rem' }}>
            <Grid.Column width={16}>
              <span style={{ ...styles.labelColored, ...styles.labelBold }}>
                Ineligible Lanes
              </span>
            </Grid.Column>
          </Grid.Row>
          {/* Ineligible Lanes Table */}
          <Grid.Row>
            <Grid.Column width={16}>
              {location.ineligibleLanes
              && location.ineligibleLanes.length > 0 ? (
                <Table basic='very' compact>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Lane Number</Table.HeaderCell>
                      <Table.HeaderCell>Ineligible Code</Table.HeaderCell>
                      <Table.HeaderCell textAlign='right'>
                        Start Date
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign='right'>
                        End Date
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {location.ineligibleLanes.map(lane => (
                      <Table.Row key={`${lane.laneNumber}-${lane.ineligibleCode}`}>
                        <Table.Cell>{lane.laneNumber}</Table.Cell>
                        <Table.Cell>{lane.ineligibleCode}</Table.Cell>
                        <Table.Cell textAlign='right'>
                          {lane.laneStartDate
                            ? moment(lane.laneStartDate).format(dateformat)
                            : ''}
                        </Table.Cell>
                        <Table.Cell textAlign='right'>
                          {lane.laneEndDate
                            ? moment(lane.laneEndDate).format(dateformat)
                            : ''}
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
                ) : (
                  <p>No ineligible lanes found.</p>
                )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

AdditionalDetailsLocation.propTypes = {
  location: PropTypes.shape({
    locationName: PropTypes.string,
    locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dsStartDate: PropTypes.string,
    dsEndDate: PropTypes.string,
    psiStartDate: PropTypes.string,
    psiEndDate: PropTypes.string,
    dsPsiStartDate: PropTypes.string,
    dsPsiEndDate: PropTypes.string,
    ineligibleLanes: PropTypes.arrayOf(PropTypes.shape({
      laneNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      ineligibleCode: PropTypes.string,
      laneStartDate: PropTypes.string,
      laneEndDate: PropTypes.string,
    })),
  }).isRequired,
  onCloseHandler: PropTypes.func.isRequired,
};

export default AdditionalDetailsLocation;
